export const gambleCardsEnum = {
  red: 1,
  black: 2,
};

export const flipCardEnum = {
  red: 'red',
  black: 'black',
};
